import React from "react";

import { Card as AntCard } from "antd";

import { Icon, Typography } from "components";

export const TablePanel = ({
  extra = null,
  headline,
  badges = null,
  image = null,
  icon = null,
  tag = null,
  onClick = null,
  className = "",
  dataTestId = "",
  subtitle = null,
}) => (
  <AntCard data-testid={dataTestId || headline} className={`table-panel ${className} ${onClick ? "pointer" : ""}`} onClick={onClick}>
    {image || (icon && <div className="image-container">{image || <Icon iconName={icon} size="m" />}</div>)}
    <div className={`left ${(image || icon) && "margin-left-50"}`}>
      {tag}
      <Typography variant="h6" className="left">
        {headline}
        {badges && <span className="badges">{badges}</span>}
      </Typography>
      {subtitle && (
        <Typography variant="paragraph-xs" color="grey-600">
          {subtitle}
        </Typography>
      )}
    </div>
    {extra}
  </AntCard>
);

export default TablePanel;
